import Chart from 'react-apexcharts'
import { useCallback, useEffect, useState } from 'react'
import { twinFetchPostJSON } from '../../../../utils/globals/data'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import './quotesellers.sass'
import useDictMonths from '../../../../utils/hooks/useDictMonths'

interface DSBQuoteSellersProps extends DSBQuoteSellersLogicProps {
    title?: string
}

const DSBQuoteSellers = ({ quoteStatus, title, end_date, start_date }: DSBQuoteSellersProps) => {
    const { quotes } = useDSBQuoteSellersLogic({quoteStatus, end_date, start_date})
    const { arrMonthShort } = useDictMonths()

    const customlegendFormatter = (name: any) => {
        return `<div class='legend-label'>${name}</div>`
    }
    const series: {
        name: string
        data: any
    }[] = []

    for (const key in quotes) {
        const item = quotes[key]
        series.push(item)
    }
    return (
        <div className='flex flex-col flex-auto h-1 gap-10 quote_sellers'>
            <h3>{title}</h3>
            <div className='flex-auto h-1'>
                <Chart options={{
                    chart: {
                        type: 'bar',
                        stacked: true,
                        events: {
                            mounted: (chart) => {
                                chart.windowResizeHandler()
                            }
                        },
                        toolbar: {
                            show: false
                        },
                        zoom: {
                            enabled: true
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '100%',
                        },
                    },
                    stroke: {
                        show: true,
                        width: 2,
                    },
                    yaxis: {
                        labels: {
                            style: {
                                colors: '#8F9BA4',
                                fontFamily: 'Roboto'
                            }
                        },
                        max: 100,
                    },
                    xaxis: {
                        labels: {
                            style: {
                                fontFamily: 'Roboto',
                                colors: '#8F9BA4',
                            }
                        },
                        categories: arrMonthShort
                    },
                    fill: {
                        opacity: 1,
                    },
                    legend: {
                        position: 'top',
                        horizontalAlign: 'left',
                        formatter: customlegendFormatter,
                        fontFamily: 'Roboto',
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return val + "%"
                            }
                        }
                    }
                }} series={series} type="bar" height={'100%'} />
            </div>
            
        </div>
    )
}

interface DSBQuoteSellersLogicProps {
    quoteStatus: number[]
    start_date: Date
    end_date: Date
}

const useDSBQuoteSellersLogic = ({ quoteStatus, end_date, start_date }: DSBQuoteSellersLogicProps) => {
    const [quotes, setQuotes] = useState<TwinDictionary>({})

    const getData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/quote/getAllQuoteOrdersCompleteForStats', {
            attributes: ['CreateEmployeeId',  'createdAt'],
            where: { 'QuoteOrder.createdAt': { '$betweenN': [start_date, end_date] }, status: { '$or': quoteStatus }, is_last: true }
        })

        let employeesDict: TwinDictionary = {}
        if (result) {
            let myTotals = Array(12).fill(0)
            for (const element of result) {
                const date = new Date(element.createdAt)
                const month = date.getMonth()
                if (!employeesDict[element.CreateEmployeeId]) {
                    employeesDict[element.CreateEmployeeId] = {
                        name: element?.RepresentativeEmployee?.fullname_short,
                        data: Array(12).fill(0),
                    }
                }
                employeesDict[element.CreateEmployeeId].data[month] = employeesDict[element.CreateEmployeeId].data[month] + 1
                myTotals[month] += 1
            }
            for (const key in employeesDict) {
                for (const keyMonth in myTotals) {
                    const myMonth = employeesDict[key].data[keyMonth]
                    employeesDict[key].data[keyMonth] = (myTotals[keyMonth] ? (myMonth * 100) / myTotals[keyMonth] : 0).toFixed(2)
                }
            }
            setQuotes(employeesDict)
        }
    }, [setQuotes, quoteStatus, start_date, end_date])

    useEffect(() => {
        getData()
    }, [getData])

    return { quotes }
}


export default DSBQuoteSellers